/* eslint @typescript-eslint/ban-ts-comment: 0 */
// @ts-ignore
import * as itemListData from '@/assets/data';

// TODO: fix sorting inside data instead of sorting here
// TODO: add back hour/month so title can be set
const comp = (a: any, b: any) => a.index - b.index;
export const filter = (filters: any, filtersKeys: any) => (item: any) => {
	const monthNotAvailable = filtersKeys.indexOf('endsBy') === -1;
	const monthNotSelected = !filters.endsBy && !filters.availableBy;
	const endsBySelectedMonth =
		filters.endsBy && item.endsBy && item.endsBy.includes(filters.endsBy);
	const availableBySelectedMonth =
		filters.availableBy &&
		item.availableBy &&
		item.availableBy.includes(filters.availableBy);

	const monthIsGood =
		monthNotAvailable ||
		monthNotSelected ||
		endsBySelectedMonth ||
		availableBySelectedMonth;

	const hourNotAvailable = filtersKeys.indexOf('hoursBy') === -1;
	const hourIsGood =
		hourNotAvailable ||
		!filters.hoursBy ||
		(item.hoursBy && item.hoursBy.includes(filters.hoursBy));

	const itemIsDonated = item.donated === true || !!item.donated.length;
	const donatedIsGood =
		(filters.donated !== true && filters.donated !== false) ||
		(itemIsDonated && filters.donated === true) ||
		(!itemIsDonated && filters.donated === false);

	return monthIsGood && hourIsGood && donatedIsGood;
};

export const getItemListData = (c: any) => {
	// @ts-ignore
	if (Array.isArray(itemListData[c])) {
		// @ts-ignore
		return itemListData[c].sort(comp);
	}

	// @ts-ignore
	return Object.entries(itemListData[c]).map(([index, i]) => ({ ...i, index }));
};

export const itemIsDonated = (isDonated: any, item: any) => {
	if (isDonated === undefined) return false;
	if (item.variations) {
		const variations = Object.keys(item.variations);
		const donated = variations.filter(
			(v) => isDonated.indexOf(`${item.index}:${v}`) !== -1
		);
		return donated.length ? donated : false;
	}
	return isDonated.indexOf(item.index) !== -1;
};
